import React from 'react';
import { APIProvider } from '@vis.gl/react-google-maps';
import { ReactComponent as LocationIcon } from 'src/assets/icons/location.svg';
import { locale } from 'src/i18n';
import keys from 'src/i18n/keys';
import { getDecryptedEnvValue } from 'src/workspace/utils';
import LocationInput, { Props } from './locationContent';
import styles from './index.module.scss';

const GOOGLE_API_KEY = getDecryptedEnvValue('GOOGLE_API_KEY');

function Location(props: Props) {
  const { viewMode, value } = props;

  if (viewMode) {
    if (value && Object.keys(value)?.length) {
      return (
        <span className={styles.locationViewWrapper}>
          <LocationIcon />
          <a
            href={`https://www.google.com/maps/search/?api=1&query=${
              value?.latitude || value?.geometry?.location?.lat
            },${value?.longitude || value?.geometry?.location?.lng}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {value?.address_string ||
              value?.formatted_address ||
              value?.name ||
              locale(keys.VIEW_ON_GOOGLE_MAPS)}
          </a>
        </span>
      );
    }
    return <span>-</span>;
  }

  return (
    <APIProvider apiKey={GOOGLE_API_KEY || ''}>
      <LocationInput {...props} />
    </APIProvider>
  );
}

export default React.memo(Location);
